import { render, staticRenderFns } from "./SelectBank.vue?vue&type=template&id=223eb462&"
import script from "./SelectBank.vue?vue&type=script&lang=js&"
export * from "./SelectBank.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports